<app-secondary-button title="ONNX_PROCESS_CONFIGURE" icon="pi pi-cog" size="small" (action)="open()" />

<p-dialog [visible]="visible()" (visibleChange)="close()" [header]="'ONNX_PROCESS_CONFIGURE' | translate"
  [modal]="true" [closable]="!saving()" [closeOnEscape]="!saving()" [draggable]="false"
  [style]="{width: '640px', maxWidth: '95vw'}" appendTo="body">
  <div class="model-settings">
    <p>{{ 'ONNX_PROCESS_PRECEDENCE' | translate }}</p>
    @if (loading()) {
      <app-loading [loading]="true" />
    } @else if (loadError()) {
      <p class="error-message" role="alert">{{ 'ONNX_PROCESS_LOAD_ERROR' | translate }}</p>
    } @else {
      <p><strong>{{ 'ONNX_PROCESS_CURRENT' | translate }}</strong>
        {{ currentLabel() || ('ONNX_PROCESS_UNSET' | translate) }}</p>
      @if (options().length) {
        <div [attr.inert]="saving() ? '' : null">
          <label>{{ 'ONNX_PROCESS_MODEL' | translate }}</label>
          <msf-select [model]="selectedId()" (modelChange)="select($event)" [options]="options()"
            optionLabel="label" optionValue="id" translateBy="none" [showClear]="true"
            [placeholder]="'ONNX_PROCESS_SELECT' | translate" />
        </div>
      } @else {
        <p>{{ 'ONNX_PROCESS_EMPTY' | translate }}</p>
      }
    }
    <a routerLink="/admin/ai-models" (click)="close()">{{ 'ONNX_PROCESS_REGISTRY' | translate }}</a>
    @if (saveError()) { <p class="error-message" role="alert">{{ 'ONNX_PROCESS_SAVE_ERROR' | translate }}</p> }
    @if (saved()) { <p role="status">{{ 'ONNX_PROCESS_SAVED' | translate }}</p> }
  </div>
  <ng-template pTemplate="footer">
    <app-secondary-button title="AI_MODELS_REFRESH" [disable]="loading() || saving()" (action)="reload()" />
    <app-secondary-button title="AI_MODELS_CANCEL" [disable]="saving()" (action)="close()" />
    <app-primary-button title="AI_MODELS_SAVE" [disable]="!canSave()" [loading]="saving()" (action)="save()" />
  </ng-template>
</p-dialog>
